export default class fullPageDBselection {
    constructor(fullPageDBselection) {
        /***
         * @param dbSelection
         * @type HTML ELEMENT
         * @props selectors
         * @type {{checkBoxesAction: string}}
         */
        this.selectors = {
            checkBoxesAction: '.db-js-check-action',
            selectAllDBinGroupCheckbox: '.js-select-all-db-in-group',
            expandableBox: '.expandable-box',
            checkBoxesWrap: '.db-js-checkboxes-wrap',
            allCheckBoxes: 'input:not(:disabled)',
            dbCheckboxes: 'input:not(:disabled).js-database-checkbox',
            dbCheckboxesClass: 'js-database-checkbox',
            dbSelectedCheckBoxes: 'input:checked.js-database-checkbox',
            useSelectedDB: '.db-js-use-btn',
            error: '.db-js-error',
            dbCancelBtn: '.db-js-cancel-btn',
            expandedByDefault: 'a.accordion__control.expandedByDefault-js-true',
            changeViewButtons: '.full-page-database-selection__view-type a',
        };

        this.animationClasses = {
            loading: 'db-selection-loading',
            success: 'db-selection-success',
        };
        this.errorClass = {
            hide: 'db-hide-force',
        };
        this.alerts = {
            checkBoxes: 'Please select at least one database',
        };
        this.fetchError = '';

        this.fullPageDBselection = fullPageDBselection;

        this.handleExpandedByDefault();

        this.selectAllDBinGroup();
        this.dbCheckboxesClicked();

        this.selectCheckBoxBtn();
        this.databaseAjax();

        this.cancelButton();

        this.getRedirectLink();

        this.changeView();
    }

    changeView() {
        const changeViewButtons = this._convertToArray(
            this.fullPageDBselection.querySelectorAll(this.selectors.changeViewButtons)
        );
        if (!changeViewButtons.length) return;

        changeViewButtons.forEach(button => {
            button.addEventListener('click', this._handleChangeViewButtons.bind(this, button, changeViewButtons));
        });
    }

    _handleChangeViewButtons(clickedButton, changeViewButtons) {
        $('.full-page-database-selection__accordion-dropzone').toggle();
        $('.full-page-database-selection__database-entries-dropzone').toggle();
        changeViewButtons.forEach(button => {
            button.classList.remove('selected');
        });
        clickedButton.classList.add('selected');

        // To save the selected value in cookie
        let detailedView = clickedButton.classList.contains('js-detailed-view');
        // fetch(`/pb/widgets/fullPageDBselection/viewType?detailed=${detailedView}`);
        // Since FE faces an issues to set the cookie from his side, I added it from our side.
        document.cookie = `db_selection_detailed_view=` + detailedView;
    }

    getRedirectLink() {
        let redirectLink = '/';
        const href = new URL(window.location.href);
        if (href.searchParams.get('redirectUri')) {
            redirectLink = new URL(window.location.href).search.split('?redirectUri=')[1];
        }
        this.redirectLink = redirectLink;
    }

    selectAllDBinGroup() {
        const groupCheckboxes = this._convertToArray(
            this.fullPageDBselection.querySelectorAll(this.selectors.selectAllDBinGroupCheckbox)
        );
        if (!groupCheckboxes.length) return;

        groupCheckboxes.forEach(button => {
            button.addEventListener('change', this._handleSelectAllDBinGroup.bind(this, button));
        });
    }

    /***
     * @param button
     * @type HTML ELEMENT
     * @private _handleSelectAllDBinGroup
     */
    _handleSelectAllDBinGroup(clickedButton) {
        const checkBoxesWrap = clickedButton
            .closest(this.selectors.expandableBox)
            .querySelector(this.selectors.checkBoxesWrap);
        if (!checkBoxesWrap) return;

        const checkBoxesInGroup = this._convertToArray(checkBoxesWrap.querySelectorAll(this.selectors.dbCheckboxes));
        if (!checkBoxesInGroup.length) return;

        checkBoxesInGroup.forEach(checkBox => {
            checkBox.checked = clickedButton.checked;
            this._handleSyncCheckboxes(checkBox);
        });
        this._removeDisableFromButton(clickedButton);
    }

    handleExpandedByDefault() {
        const expandedByDefaultGroups = this._convertToArray(
            this.fullPageDBselection.querySelectorAll(this.selectors.expandedByDefault)
        );
        if (!expandedByDefaultGroups.length) return;

        expandedByDefaultGroups.forEach(group => group.click());
    }

    dbCheckboxesClicked() {
        const checkboxes = this._convertToArray(this.fullPageDBselection.querySelectorAll(this.selectors.dbCheckboxes));
        if (!checkboxes.length) return;
        this.fullPageDBselection.checkboxes = checkboxes;

        checkboxes.forEach(button => {
            button.addEventListener('change', this._handleDBCheckboxesClicked.bind(this, button));
        });
    }

    _handleDBCheckboxesClicked(clickedButton) {
        this._handleSyncCheckboxes(clickedButton);
        this._removeDisableFromButton(clickedButton);
        this._checkStatusOfGroupCheckbox(clickedButton);
    }

    /***
     * @param button
     * @type HTML ELEMENT
     * @private _handleSyncCheckboxes
     */
    _handleSyncCheckboxes(clickedButton) {
        this.fullPageDBselection.checkboxes.forEach(checkBox => {
            if (checkBox.dataset?.id === clickedButton.dataset?.id) {
                checkBox.checked = clickedButton.checked;
                if (clickedButton.dataset.groupReference === 'dbFlattenedItems') {
                    this._checkStatusOfGroupCheckbox(checkBox);
                }
            }
        });
    }

    _removeDisableFromButton(clickedButton) {
        if (!clickedButton?.disabled && clickedButton?.localName === 'input' && clickedButton?.type === 'checkbox') {
            const disabledAction = this.fullPageDBselection.querySelector(
                `${this.selectors.checkBoxesAction}:disabled`
            );
            if (disabledAction?.disabled) {
                disabledAction.disabled = false;
            }
        }
    }

    _checkStatusOfGroupCheckbox(clickedButton) {
        var checkGroupCheckbox = true;
        const groupCheckboxForClickedButton = this.fullPageDBselection.querySelector(
            `${this.selectors.selectAllDBinGroupCheckbox}[data-group-checkbox-for=${clickedButton.dataset?.groupReference}]`
        );
        if (!groupCheckboxForClickedButton) return;

        this.fullPageDBselection.checkboxes.forEach(checkBox => {
            if (checkBox.dataset?.groupReference === clickedButton.dataset?.groupReference) {
                if (!checkBox.checked) {
                    checkGroupCheckbox = false;
                }
            }
        });

        groupCheckboxForClickedButton.checked = checkGroupCheckbox;
    }

    selectCheckBoxBtn() {
        const actionBtns = this._convertToArray(
            this.fullPageDBselection.querySelectorAll(this.selectors.checkBoxesAction)
        );
        const htmlBtn = {};
        if (!actionBtns.length) return;

        actionBtns.forEach(button => {
            const action = button?.dataset?.action;
            htmlBtn[action] = button;
            button.addEventListener('click', this._handleSelectAction.bind(this, button, action, htmlBtn));
        });
    }

    /***
     * @param button
     * @type HTML ELEMENT
     * @private _handleSelectAction
     */
    _handleSelectAction(button, action, htmlBtn) {
        const allCheckBoxes = this._convertToArray(
            this.fullPageDBselection.querySelectorAll(this.selectors.allCheckBoxes)
        );
        if (!allCheckBoxes.length) return;

        switch (action) {
            case 'selectAll':
                this._disableController(htmlBtn, [true, false, false]);
                allCheckBoxes.forEach(checkBox => (checkBox.checked = true));
                break;
            case 'clearAll':
                allCheckBoxes.forEach(checkBox => (checkBox.checked = false));
                this._disableController(htmlBtn, [false, true, false]);
                break;
            case 'selectAccess':
                this._disableController(htmlBtn, [false, false, true]);
                allCheckBoxes.forEach(checkBox => {
                    const available = checkBox?.dataset?.available;
                    if (available && available === 'true') {
                        checkBox.checked = true;
                    } else {
                        checkBox.checked = false;
                    }
                    // to sync group checkbox when click on the Have Access To button
                    if (
                        checkBox.classList.contains(this.selectors.dbCheckboxesClass) &&
                        available &&
                        available === 'true'
                    ) {
                        this._checkStatusOfGroupCheckbox(checkBox);
                    }
                });
        }
    }

    /****
     *
     * @param element
     * @param siteName
     * @param values ['selectAll' , 'clearAll' , 'selectAccess'] || true or false values
     * @private
     */
    _disableController(element, values) {
        const labels = ['selectAll', 'clearAll', 'selectAccess'];
        labels.forEach((label, index) => {
            element[label] ? (element[label].disabled = values[index]) : false;
        });
    }

    cancelButton() {
        const cancelButton = this._convertToArray(
            this.fullPageDBselection.querySelectorAll(this.selectors.dbCancelBtn)
        );
        if (!cancelButton) return;

        cancelButton.forEach(button => {
            button.addEventListener('click', this._handleCancel.bind(this));
        });
    }

    _handleCancel() {
        location.href = this.redirectLink;
    }

    /***
     * @INFO AJAX EON BUTTON EVENT
     */
    databaseAjax() {
        const useSelectedDB = this._convertToArray(
            this.fullPageDBselection.querySelectorAll(this.selectors.useSelectedDB)
        );
        if (!useSelectedDB) return;

        useSelectedDB.forEach(button => {
            button.addEventListener('click', this._handleAjax.bind(this));
        });
    }

    /***
     * @INFO AJAX CALL FUNCTION
     * @private
     */
    _handleAjax() {
        const {ajaxUrl, href, checkBoxesError} = this._buildAjaxUrl() || {};
        const error = this.fullPageDBselection.querySelector(this.selectors.error);
        if (checkBoxesError && (error?.textContent === '' || this.fetchError === error?.textContent)) {
            error.textContent = checkBoxesError;
            this.fetchError = '';
            error.parentElement.classList.remove(this.errorClass.hide);
            return;
        } else if (!checkBoxesError && !this.fetchError) {
            error.textContent = '';
            error.parentElement.classList.add(this.errorClass.hide);
        }

        if (ajaxUrl && error?.textContent === '') {
            const mainWidgetContainer = this.fullPageDBselection;
            mainWidgetContainer?.classList.add(this.animationClasses.loading);
            fetch(ajaxUrl)
                .then(response => response.text())
                .then(data => {
                    if (data.trim() === 'SUCCESS') {
                        mainWidgetContainer.classList.add(this.animationClasses.success);
                        error.parentElement.classList.add(this.errorClass.hide);
                        this.fetchError = '';
                        location.href = href;
                    } else {
                        mainWidgetContainer.classList.remove(this.animationClasses.loading);
                        error.textContent = data;
                        error.parentElement.classList.remove(this.errorClass.hide);
                        this.fetchError = data;
                    }
                })
                .catch(error => {
                    mainWidgetContainer.classList.remove(this.animationClasses.loading);
                    this.fetchError = error;
                    error.parentElement.classList.remove(this.errorClass.hide);
                });
        }
    }

    /***
     * @INFO BUILD AJAX LINK & RETURN HREF
     * @returns {{ajaxUrl: string, href: string}}
     * @private
     */
    _buildAjaxUrl() {
        const mianWidget = this.fullPageDBselection;
        const widgetId = mianWidget?.dataset?.id;
        const pbContext = document.head?.querySelector('[name="pbContext"]')?.content;
        const selectedCheckBox = this._convertToArray(
            this.fullPageDBselection.querySelectorAll(this.selectors.dbSelectedCheckBoxes)
        );
        const href = this.redirectLink;
        let stringSelectedCheckBox = null;
        let checkBoxesError = null;
        if (selectedCheckBox.length) {
            stringSelectedCheckBox = selectedCheckBox
                .map(checkBox => {
                    if (checkBox?.dataset?.id) return `dbId=${checkBox.dataset.id}`;
                })
                .join('&');
        } else {
            checkBoxesError = this.alerts.checkBoxes;
        }

        if (!widgetId && !pbContext) return null;

        return {
            ajaxUrl: `/pb/widgets/fullPageDBselection?widgetId=${widgetId}&pbContext=${pbContext}&${stringSelectedCheckBox}`,
            href,
            checkBoxesError,
        };
    }
    /***
     * @param nodeList
     * @returns {[]}
     * @private
     */
    _convertToArray(nodeList) {
        return Array.prototype.slice.call(nodeList);
    }
}
